import React from "react";
import { callable } from "../../common/userAgent";
import { openContact, getPhoneNumber } from "../../common/callUtil";
import masterData from "../../lib/masterData";
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { DynamicContent, isVisibleContent } from "../../common/DynamicContent";

export const callcenter = type => {
  return (
    <div className="callcenter">
      <MasterDataReady
        schemaIds={["excComment"]}
        render={() => {
          if (isVisibleContent(masterData.excComment.modalVisitor)) {
            return (
              <div className="content">
                <DynamicContent
                  params={masterData.excComment.top}
                  type={type}
                />
              </div>
            );
          } else {
            return (
              <div className="content">
                <div className="docall">
                  <span>各サービス詳細はコールセンターに</span>
                  <span>お問い合わせください。</span>
                </div>
                <div className="phone_number">
                  <img src="resource/img/phone.png" />
                  {(() => {
                    if (!callable) {
                      return getPhoneNumber("common_main");
                    } else {
                      return (
                        <a
                          className="phone_link"
                          onClick={() =>
                            openContact("common_main", {
                              eventTrackingId: "tel_action_top_middle",
                            })
                          }
                        >
                          {getPhoneNumber("common_main")}
                        </a>
                      );
                    }
                  })()}
                </div>
              </div>
            );
          }
        }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/top/callcenter.jsx